import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
// <div data-controller="clipboard">
//   <input data-clipboard-target="source" value="…" readonly>
//   <button data-clipboard-target="button" data-action="clipboard#copy">Copy</button>
// </div>
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = this.sourceTarget.value
    navigator.clipboard.writeText(text).then(() => this.flash())
  }

  flash() {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.dataset.label || this.buttonTarget.textContent
    this.buttonTarget.dataset.label = original
    this.buttonTarget.textContent = "Copied"
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
  }
}
